import { Injectable, inject } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { Guard } from './guard';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard extends Guard {

  async canActivate(): Promise<boolean> {
    const allowedRole = 'admin';
    const userRoles = await this.authenticationService.getRoles();
    if (!userRoles) {
      console.log('AdminGuard:canActivate', userRoles);
      return false;
    }
    return userRoles.includes(allowedRole);
  }
}
